import { AbstractDto, ReadWriteField } from "./AbstractDto";

export default class ExamResults extends AbstractDto<ExamResults> {

    @ReadWriteField
    public theory: number[] = [];

    @ReadWriteField
    public exercises: number[] = [];

    @ReadWriteField
    public version: string;

    exist(): boolean {
        return this.theory.length > 0;
    }

    getPoints(): number {
        let points = 0;
        points += this.theory.reduce((a: number, b: number) => a + b, 0);
        points += this.exercises.reduce((a: number, b: number) => a + b, 0);

        return points;
    }
}
